export enum FaqSurveyAnswerEnum {
  POSITIVA = 0,
  NEGATIVA = 1
}
